import styles from './baseSignItem.module.css';
import mainStyles from '../../main.module.css';
import Formatter from '../../../utils/formatters';

/**
 * ファイルインポート接続ステータスバーコンポーネント
 *
 * @param updateDate - 更新日時
 */
function FileImportConnectingStatusBar({ updateDate }:{ updateDate: string }) {
  return (
    <div className={[styles.textLight, mainStyles['mt-1']].join(' ')}>
      <span className={mainStyles['mr-3']}>
        {Formatter.toDisplayDate(Formatter.fromStringToDate(updateDate), Formatter.defaultDateTimeFormat)}
        {'  '}
        に連携を開始しました。
      </span>
    </div>
  );
}

export default FileImportConnectingStatusBar;
